import { useMemo } from 'react'
import dayjs from '@ucheba/utils/helpers/date/dayjs'
import { IUseOlympiadsListItemCore } from './types'
import { olympiadPath } from './contants'

export const useOlympiadHref = (id: number): string => {
  return useMemo(() => `${olympiadPath}/${id}`, [id])
}

export const useImageColWidth = (width: string): string => {
  return useMemo(() => `${parseInt(width, 10) + 32}px`, [width])
}

export const useOlympiadsListItemCore: IUseOlympiadsListItemCore = ({
  stages,
  classFrom,
  classTo,
  levelFrom,
  levelTo,
}) => {
  const dates = useMemo(() => {
    if (!stages.length) return ''

    const from = dayjs(stages[0].dateFrom).format('DD MMMM')
    const to = dayjs(stages[0].dateTo).format('DD MMMM')

    return `${from} - ${to}`
  }, [stages])
  const datesType = useMemo(() => (stages.length ? stages[0].typeName : ''), [stages])
  const level = useMemo(
    () =>
      levelFrom && levelTo
        ? {
            entity: levelFrom === levelTo ? levelFrom : `${levelFrom}-${levelTo}`,
            clarification: 'уровень',
          }
        : null,
    [levelFrom, levelTo]
  )
  const classes = useMemo(
    () =>
      classFrom && classTo
        ? {
            entity: classFrom === classTo ? classFrom : `${classFrom}-${classTo}`,
            clarification: 'классы',
          }
        : null,
    [classFrom, classTo]
  )

  return {
    dates,
    datesType,
    level,
    classes,
  }
}
